import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class LimiteCompraItem extends Component {
    constructor(props) {
        super(props)

        this.setHoverOn = this.setHoverOn.bind(this);
        this.setHoverOut = this.setHoverOut.bind(this);

        this.state = {
            isHoverOn: false
        }
    }

    setHoverOn() {
        this.setState({
            isHoverOn: true
        })
    }

    setHoverOut() {
        this.setState({
            isHoverOn: false
        })
    }

    render() {
        return (
            <div onMouseOver={this.setHoverOn} onMouseLeave={this.setHoverOut} >
                <div key={"checkPurchaseLimits" + this.props.id} className="row">
                    <div key={"checkPurchaseLimits" + this.props.id} className="col-xs-12">
                        <ul className="no-bullets no-padding no-margin">
                            <li className="inlineListItem2 lg-margin">
                                <div className="default-checkbox">
                                    <input key={"checkPurchaseLimits" + this.props.id} id={"checkPurchaseLimits" + this.props.id} name={"checkPurchaseLimits" + this.props.id} type="checkbox" checked={this.props.checked} onChange={() => this.props.checkItem(this.props.id)} />
                                    <label className="label-primary" htmlFor={"checkPurchaseLimits" + this.props.id}></label>
                                </div>
                            </li>
                            <li className="inlineListItem2">
                                <label className="label-primary" htmlFor={"checkPurchaseLimits" + this.props.id}>{this.props.codigoValor}</label>
                            </li>
                            {this.state.isHoverOn == true ? <li className="inlineListItem2 item-pull-right"><GenericSimpleButton text="Marcar este y los siguientes" buttonType="button" buttonClass="btn-link btn-link-secondary" onClick={() => this.props.checkThisAndAllNext(this.props.id, this.props.valor)} /></li> : null}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
};

export default LimiteCompraItem;